class Testimonials extends HTMLElement {
  constructor() {
    super();

    const slider = this.querySelector("[data-testimonials-slider]");
    if (slider) {
      $("[data-testimonials-slider]").slick({
        arrows: false
      });
    }

    const sliderNext = this.querySelector(".testimonial-slider__button--next");
    if (sliderNext) {
      sliderNext.addEventListener("click", function() {
        $("[data-testimonials-slider]").slick("slickNext");
      })
    }
    
    const sliderPrev = this.querySelector(".testimonial-slider__button--prev");
    if (sliderPrev) {
      sliderPrev.addEventListener("click", function() {
        $("[data-testimonials-slider]").slick("slickPrev");
      })
    }
  }
}

if (customElements.get("custom-testimonials") === undefined) {
  customElements.define("custom-testimonials", Testimonials);
}
